import { createQueryParams } from "./createQueryParams";
export var getEmbedUrl = function(param) {
    var preproductBaseUrl = param.preproductBaseUrl, templateKey = param.templateKey, queryParams = param.queryParams;
    var url = "".concat(preproductBaseUrl);
    if (templateKey) {
        url += "/".concat(templateKey);
    }
    if (queryParams) {
        url += "?".concat(createQueryParams(queryParams));
    }
    return url;
};
